import DataElement from "./DataElement";

import { ref } from "vue";




export function XMLStr2Viewmodel(val) {
  if (typeof val === "string") {
    val = val.replaceAll('\\n', '\n');
    val = val.replaceAll('\\\\', '\\');
  }
  return val;
}


/**
 *
 * @param {Element} node
 * @param {import("../xmlrdb-metadata/XMLRDBNavigation").default} metadata
 */
export function xmlElementToDataElement(/** @type {Element} */node, metadata, parent) {
  let attributeNames = node.getAttributeNames();
  let attributeMap = {};
  let elementMeta = metadata.getElement(node.getAttribute("meta:id"));
  
  attributeNames.forEach(attribName => {
    const attr = elementMeta.attribute(attribName)
    let val = XMLStr2Viewmodel(node.getAttribute(attribName));
    if (attr)
      val = attr.parseValue(val);
    attributeMap[attribName] = val;
  });

  let dataElement = new DataElement({ attributes: attributeMap, metadata: elementMeta, parent });
  appendSubElements(node, dataElement, metadata);
  return dataElement;
}

export function appendSubElements(node, dataElem, metadata) {
  node.childNodes.forEach(childNode => {
    if (childNode instanceof Element) { // das ist das Element aus dem Browser
      let childMetadata = metadata.getElement(childNode.getAttribute("meta:id"));
      if(childMetadata)
        dataElem.addSubElement(childMetadata, xmlElementToDataElement(childNode, metadata, dataElem), true);
      else {
        elementWithoutMetadataToJS(childNode, dataElem);
      }
    }
  });
}



function xmlToColumnSum(dataElem, childNode) {
  let sums = dataElem.__[childNode.getAttribute("id")].columnSum;
  childNode.getAttributeNames().forEach(a => {
    if (a !== "id") {
      if (Object.prototype.hasOwnProperty.call(sums, a)) {
        sums[a].value = Number(childNode.getAttribute(a));
      }
      else {
        sums[a] = ref(Number(childNode.getAttribute(a)));
      }
    }
  });
}

export function elementWithoutMetadataToJS(childNode, dataElem) {
  if (childNode.tagName === "meta:ColumnSum") {
    xmlToColumnSum(dataElem, childNode);
  }
  else if (childNode.tagName === "meta:ItemCount") {
    dataElem.__[childNode.getAttribute("id")].count.value = Number(childNode.getAttribute("count"))
  }
  else {
    const nodeName = childNode.tagName;
    const newElem = {};

    childNode.getAttributeNames().forEach(a => {
      newElem[a] = childNode.getAttribute(a);
    });

    if (dataElem.extraData.value[nodeName]) {
      dataElem.extraData.value[nodeName].push(newElem);
    }
    else {
      dataElem.extraData.value[nodeName] = [newElem];
    }
  }
}